<template>
	<div class="store-content item">
		<div class="item-box">
			<div class="gallery-wrapper">
				<div class="gallery">
					<div class="thumbnail">
						<ul>
							<li :class="{'on':index===currentIndex}" v-for="(item,index) in selectedItem.ali_images" @mouseover="change(index)">
								<img :src="item.image+'?x-oss-process=image/resize,w_54/quality,Q_90/format,webp'">
							</li>
						</ul>
					</div>
					<div class="thumb">
						<ul>
							<li :class="{'on':index===currentIndex}" v-for="(item,index) in selectedItem.ali_images">
								<img :src="item.image+'?x-oss-process=image/resize,w_440/quality,Q_90/format,webp'">
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="banner">
				<div class="sku-custom-title">
					<div class="params-info">
						<h4>{{selectedItem.title}}</h4>
						<h6>{{selectedItem.sub_title}}</h6>
					</div>
					<div class="params-model">
						<span><em>型号：&nbsp;&nbsp;&nbsp;&nbsp;</em><i>{{selectedItem.model}}</i></span>
					</div>
				</div>
				<div class="sku-dynamic-params-panel">
					<div class="sku-tech-title ">
						<span class="">技术参数</span>
					</div>
					<ul>
						<li class="sku-tech-item" v-for="(item,index) in selectedItem.tech">
							{{item}}
						</li>
					</ul>
				</div>
			</div>
			<div id="goback" style=" ">
				<a @click="$router.go(-1)" style="">
					返回
				</a>
			</div>
		</div>

		<div class="item-box" v-show="pdfUrl!==''">
			<div class="sku-tech-title ">
				<span class="">产品详情</span>
			</div>
			<!--{{selectedItem.detail}}-->​
			<pdf v-for="item in pageTotal" :src="pdfUrl" :key="item" :page="item">
			</pdf>
		</div>
	</div>

</template>

<script>
	import itemData from '@/lib/remoteKeysDetailData.js'
	import pdf from 'vue-pdf'

	export default {
		data() {
			return {
				itemData,
				productId: this.$route.query.productId,
				currentIndex: 0,
				pageTotal: null,
				pdfUrl: '',
			}
		},
		components: {
			pdf
		},
		created() {
			// 具体函数调用位置根据情况而定
			console.log('retmotekey created,productId:' + this.productId);
			let info = this.itemData.filter((item) => {
				return Number(item.sku_id) === Number(this.productId);
			})[0];
			if(typeof info.pdf_url !=='undefined' && info.pdf_url != '') {
				this.pdfUrl =this.$store.state.pdfUrl+'pdf/'+ info.pdf_url;
				console.log(this.pdfUrl);
				
				this.getTotal();
			}
		},
		computed: {
			selectedItem() {
				console.log(this.itemData);
				let itemInfo = this.itemData.filter((item) => {
					return Number(item.sku_id) === Number(this.productId);
				})[0];
				console.log(itemInfo);

				return itemInfo;
			},

		},
		methods: {
			change(index) {
				this.currentIndex = index;
				console.log(index)
			},
			// 获取pdf总页数
			getTotal() {
				// 多页pdf的src中不能直接使用后端获取的pdf地址 否则会按页数请求多次数据
				// 需要使用下述方法的返回值作为url
				this.pdfUrl = pdf.createLoadingTask(this.pdfUrl)
				// 获取页码
				this.pdfUrl.promise.then(pdf => this.pageTotal = pdf.numPages).catch(error => {})
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/detail-remotekey.vue